import React from 'react';
import { InputText } from 'design-system/Form';

interface IStringInputProps {
  initialInput?: string;
  onValidEntry?(strings: string[]): void;
  onEntry?(strings: string[] | undefined): void;
  labelPrompt?: string;
  hideLabelPrompt?: boolean;
  placeholder?: string;
  stopPropagation?: boolean;
  onBlur?(): void;
  singleString?: boolean;
  preventDuplicates?: boolean;
}

interface IStringInputState {
  currentInput: string;
  isValid: boolean;
}

/** TODO refactor to use `design-system/TextInput` */
class StringInput extends React.Component<IStringInputProps, IStringInputState> {
  constructor(props: IStringInputProps) {
    super(props);
    const initialInput = props.initialInput || '';
    this.state = {
      currentInput: initialInput,
      isValid: this.getStrings(initialInput) !== undefined,
    };
  }

  getStrings(currentInput: $FIXME) {
    if (currentInput === undefined) {
      return currentInput;
    }
    const strings = currentInput
      .trim()
      .split(/[,\s]+/g)
      .map((el: $FIXME) => el.trim())
      .filter((el: $FIXME) => el !== '');

    if (this.props.singleString && strings.length > 1) {
      return undefined;
    }

    if (this.props.preventDuplicates && new Set(strings).size !== strings.length) {
      return undefined;
    }

    return strings;
  }

  onChange(e: $FIXME) {
    const currentInput = e.target.value;
    const strings = this.getStrings(currentInput);
    const isValid = strings !== undefined;
    this.setState({
      currentInput,
      isValid,
    });

    if (isValid && this.props.onValidEntry) {
      // @ts-ignore FIXME - Typescript Strict [2722]
      this.props.onValidEntry(strings);
    }

    if (this.props.onEntry) {
      this.props.onEntry(strings);
    }

    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
  }

  render() {
    return (
      <div>
        {this.props.hideLabelPrompt !== true && (
          <strong>{this.props.labelPrompt || 'words'}</strong>
        )}
        <InputText
          key={this.props.initialInput}
          defaultValue={this.props.initialInput}
          onChange={this.onChange.bind(this)}
          invalid={!this.state.isValid}
          placeholder={
            this.props.placeholder ||
            `Word${this.props.singleString ? '' : 's (comma or space separated)'}`
          }
          onKeyDown={(e: $FIXME) => {
            if (this.props.stopPropagation) {
              e.stopPropagation();
            }
          }}
          onBlur={this.props.onBlur || (() => {})}
        />
      </div>
    );
  }
}

export default StringInput;
